import React, { useCallback, useEffect } from 'react';
import { useNavigation, useRoute } from '@react-navigation/core';
import { TouchableOpacity, View } from 'react-native';
import { CommonStyles } from '../../styles';
import ExpenseFormItem, { ExpenseFormInput } from '../ExpenseWidget/ExpenseFormItem';
import RowView from '../RowView';
import { Modals } from '../../constants/ScreenNames';
import moment from 'moment';
import { widgetStyles } from '../../styles/theme';

const MeetingWidget = ({ meeting, onUpdate }) => {
  const navigation = useNavigation();
  const route = useRoute();
  const { selectedLocation, selectedDates, selectedTimes } = route?.params || {};
  const dispatch = useCallback(
    ({ type, value }) => {
      onUpdate({
        id: meeting.id,
        type,
        value,
      });
    },
    [onUpdate, meeting.id]
  );

  const addressInputName = `meetingAddress-${meeting.id}`;
  const datesInputName = `meetingDates-${meeting.id}`;
  const timeInputName = `meetingTime-${meeting.id}`;

  useEffect(() => {
    if (selectedLocation && selectedLocation.inputName === addressInputName) {
      dispatch({ type: 'address', value: selectedLocation });
    }
  }, [dispatch, selectedLocation, addressInputName]);

  useEffect(() => {
    if (selectedDates?.inputName === datesInputName && selectedDates?.startDate) {
      dispatch({
        type: 'date',
        value: selectedDates?.startDate,
      });
    }
  }, [dispatch, selectedDates, datesInputName]);

  useEffect(() => {
    if (selectedTimes && selectedTimes.inputName === timeInputName) {
      dispatch({
        type: 'time',
        value: {
          minutes: selectedTimes?.startTime?.minutes,
          hours: selectedTimes?.startTime?.hours,
          displayName: selectedTimes.displayName,
        },
      });
    }
  }, [dispatch, selectedTimes, timeInputName]);

  return (
    <View style={CommonStyles.mb3}>
      <View style={widgetStyles.widget}>
        <ExpenseFormInput
          label="Meeting Name"
          value={meeting.name}
          onChangeText={(value) => dispatch({ type: 'name', value })}
          icon={!meeting.name && 'calendarCheck'}
        />
        <TouchableOpacity
          onPress={() =>
            navigation.navigate(Modals.StationAutoCompleteModal, {
              returnScreen: route.name,
              source: 'to',
              index: 0,
              hasHotel: true,
              inputName: addressInputName,
            })
          }
        >
          <ExpenseFormItem
            label="Meeting Address"
            value={meeting.address ? meeting.address.displaylabel : null}
            icon={!meeting.address && 'mark'}
            style={widgetStyles.topBorder}
          />
        </TouchableOpacity>
        <ExpenseFormInput
          label="Virtual Link"
          value={meeting.link}
          onChangeText={(value) => dispatch({ type: 'link', value })}
          icon={!meeting.link && 'link'}
          style={widgetStyles.topBorder}
        />
        <RowView style={widgetStyles.topBorder}>
          <TouchableOpacity
            style={CommonStyles.halfWidth}
            onPress={() =>
              navigation.navigate(Modals.Calendar, {
                returnScreen: route.name,
                //minDate: moment(new Date()).subtract(331, 'days').format('YYYY-MM-DD'),
                maxDate: moment(new Date()).add(331, 'days').format('YYYY-MM-DD'),
                //pastScrollRange: 10,
                futureScrollRange: 10,
                inputName: datesInputName,
                //fromDate: meeting.date,
              })
            }
          >
            <ExpenseFormItem label="Date" icon={!meeting.date && 'calendar'} value={meeting.date} />
          </TouchableOpacity>
          <TouchableOpacity
            style={widgetStyles.time}
            onPress={() =>
              navigation.navigate(Modals.TimePickerModal, {
                returnScreen: route?.name,
                selectedTimes: {
                  startTime: meeting.time,
                },
                oneTime: true,
                inputName: timeInputName,
              })
            }
          >
            <ExpenseFormItem
              label="Time"
              icon={!meeting.time && 'time'}
              value={meeting.time ? meeting.time.displayName : null}
            />
          </TouchableOpacity>
        </RowView>
      </View>
    </View>
  );
};

export default MeetingWidget;
